<template>
  <card class="pt-3 pb-3">
    <list
      :itemLink="itemLink"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :searchDisable="true"
      :isAdd="true"
      :fields="fields"
      @change="change"
      :setLink="setLink"
    />
      <!-- :functions="functions" -->
  </card>
</template>

<script>
import List from "../components/List";

export default {
  name: "draws-page",
  components: {
    List,
  },
  data() {
    return {
      // functions: [{ id: 1, title: "Установить группу" }],
      //end callback data
      /**Меняю ссылки на модель */
      modalCreate: "draw",
      removeLink: "discipline/remove",
      cardLink: "draw",
      itemLink: "admin/draws",
      setLink: "admin/draws/create",
      /**Табличные филды */
      fields: [
        {
          label: "Название",
          key: "title",
          type: "text",
        },
        {
          label: "Количество победителей",
          key: "winner_at_once",
          type: "numeric",
        },
      ],
      columns: [
         {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
              detail: true,
        },
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
        
        },
        {
          key: "id",
          title: "Продакшин",
          checkbox: false,
          control: false,
          align: "left",
          link: "https://admin.glamourboutique.uz/#/draws?card=draw_production&id=",
        },
       
        {
          key: "winner_at_once",
          title: "Количество победителей за раз",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "created_at",
          title: "Дата создания",
          checkbox: false,
          control: false,
          align: "right",
        },
      ],
      value: null,
    };
  },
  methods: {
    changeFunction(val) {
      if (val == 1) {
        this.$store.dispatch("openModal", {
          model: "group",
          route: "admin/clients/relate/group",
        });

        this.$store.dispatch("selectValue", this.value);
      }
    },
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },
  },
};
</script>
<style>
</style>
